import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { DialogContent, List, ListItemButton, ListItemText, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import loadingYardList from 'recoil/selectors/loadingYardList';
import destinationYardList from 'recoil/selectors/destinationYardList';


type YardDialogProps = {
    from?: number,
    isLoading: boolean,
} & ModalActionProps<number>

const YardDialog = ({ from, isLoading, onFinish}: YardDialogProps) => {
    const {t} = useTranslation('cars');
    const yards = useRecoilValue(isLoading ? loadingYardList : destinationYardList);
    const [filter, setFilter] = useState('');

    let filtered = filter ?
        yards.filter(y => y.name.toLowerCase().includes(filter) || y.port.name.toLowerCase().includes(filter)) :
        yards;

    if (from)
        filtered = filtered.filter(y => y.id !== from)

    filtered.sort((a, b) => a.portId - b.portId);

    return (
        <DialogContent>
            <TextField
                id="yard"
                name="yard"
                label={t('filter')}
                fullWidth
                value={filter}
                onChange={e => setFilter(e.target.value.toLowerCase())}
            />

            <List dense sx={{height: 300, overflow: 'auto',}}>
                {filtered.map(yard => (
                    <ListItemButton
                        key={yard.id}
                        onClick={() => onFinish(yard.id)}
                    >
                        <ListItemText primary={`${yard.port.name} ${yard.name} (${yard.occupied} ${t('of')} ${yard.capacity || 0})`} />
                    </ListItemButton>
                ))}
            </List>
        </DialogContent>
    );
};

export default YardDialog;
